import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { CopyIcon } from '@zorro/shared/assets';

import { CopyToClipboard } from '../../../CopyToClipboard';

type CopyToClipboardActionIconProps = {
  numberToCopy: string;
};

const CopyToClipboardActionIcon = ({
  numberToCopy,
}: CopyToClipboardActionIconProps) => {
  return (
    <CopyToClipboard text={numberToCopy}>
      <ActionIcon aria-label="copy-to-clipboard" size="sm">
        <CopyIcon style={{ width: '26px', height: '26px' }} />
      </ActionIcon>
    </CopyToClipboard>
  );
};

export default CopyToClipboardActionIcon;
